import React, { useState } from 'react';
import { Button, Label, Modal, ModalBody, ModalFooter, ModalHeader, Form, FormGroup, Table, Input } from 'reactstrap';
import { MrbItemType } from 'app/shared/model/enumerations/mrb-item-type.model';
import { IMrbItem } from 'app/shared/model/mrbItem.model';
import { VoteOutcome } from 'app/shared/model/enumerations/vote-outcome.model';
import { FieldMessage } from 'app/common/components/ui/button/FieldMessage';
import { MrbItemStatus } from 'app/shared/model/enumerations/mrb-item-status.model';
import { TextFormat } from 'react-jhipster';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

const DEFAULT_OUTCOME = VoteOutcome.CAPA_INVESTIGATION_APPROVED;
const REQUEST_NOTE_MSG = 'Enter a note for the vote';

const inPlanningStyle = {
  fontSize: '0.90rem',
};

interface IMrbItemCapa extends IMrbItem {
  itemType: MrbItemType.CAPA;
}

export interface IVotingModalProps {
  capa: IMrbItemCapa;
  showModal: boolean;
  toggleModal: Function;
  voteHandler: Function;
  rowClassName: string;
}

export const CapaVotingModal = (props: IVotingModalProps) => {
  const { capa, showModal, toggleModal, voteHandler, rowClassName } = props;

  const [note, setNote] = useState('');
  const [requestNote, setRequestNote] = useState(false);
  const [outcome, setOutcome] = useState(DEFAULT_OUTCOME);

  const resetModal = () => {
    setNote('');
    setOutcome(DEFAULT_OUTCOME);
  };

  const noteChangeHandler = event => {
    setNote(event.target.value);
    if (note) {
      setRequestNote(false);
    }
  };

  const formSubmitHandler = event => {
    event.preventDefault();
    if (note && outcome) {
      const vote = {
        note,
        outcome,
        capa: {
          id: capa.id,
        },
        createdDate: null,
        updatedDate: null,
      };
      voteHandler(vote);
      toggleModal();
      resetModal();
    }
    if (!note) {
      setRequestNote(true);
    }
  };

  const cancelHandler = () => {
    toggleModal();
    resetModal();
  };

  const buttonsBuilder = () => {
    if (capa.status === MrbItemStatus.CAPA_IN_INVESTIGATION) {
      return (
        <>
          <Button type="submit" color="success" onClick={() => setOutcome(VoteOutcome.CAPA_INVESTIGATION_APPROVED)}>
            Investigation Approved
          </Button>
          <Button type="submit" color="danger" onClick={() => setOutcome(VoteOutcome.CAPA_INVESTIGATION_CHANGE_REQUESTED)}>
            Investigation Rejected
          </Button>
          <Button type="button" className="mr-1" color="secondary" onClick={cancelHandler} tabIndex="1">
            Cancel
          </Button>
        </>
      );
    }
    if (capa.status === MrbItemStatus.CAPA_IN_PLANNING) {
      return (
        <>
          <Button
            style={inPlanningStyle}
            type="submit"
            color="success"
            onClick={() => setOutcome(VoteOutcome.CAPA_IMPLEMENTATION_PLAN_APPROVED)}
          >
            Implementation Approved
          </Button>
          <Button
            style={inPlanningStyle}
            type="submit"
            color="danger"
            onClick={() => setOutcome(VoteOutcome.CAPA_IMPLEMENTATION_PLAN_CHANGE_REQUESTED)}
          >
            Implementation Rejected
          </Button>
          <Button style={inPlanningStyle} type="button" className="mr-1" color="secondary" onClick={cancelHandler} tabIndex="1">
            Cancel
          </Button>
        </>
      );
    }
  };

  return (
    <Modal isOpen={showModal} toggle={toggleModal} className={'className'}>
      <Form onSubmit={formSubmitHandler}>
        <ModalHeader toggle={toggleModal}>Capa Vote</ModalHeader>
        <ModalBody>
          <dl className="jh-entity-details">
            <dt>
              <span id="id">ID</span>
            </dt>
            <dd>{capa.id || null}</dd>
            <dt>
              <span id="title">Incident Title</span>
            </dt>
            <dd className="text-truncate">{capa.incidentTitle || null}</dd>
          </dl>
          <FormGroup>
            <Label id="noteLabel" for="vote-note">
              Note
            </Label>
            <Input id="vote-note" type="text" name="note" value={note} placeholder="Enter a note" onChange={noteChangeHandler} />
            <FieldMessage condition={requestNote} message={REQUEST_NOTE_MSG} />
          </FormGroup>
        </ModalBody>
        <ModalFooter>{buttonsBuilder()}</ModalFooter>
      </Form>
    </Modal>
  );
};
